import type { IntlShape } from 'react-intl';
import { formMessages, specialErrorMessages } from '../messages';
import type { ErrorType, InputIDs } from '../types';
import { Errors } from '../types';

/**
 * Formats the general error placeholder string into a localized and field specific Error Message
 *
 * @param error The error string from validation framework
 * @param inputId The field which this error belongs to
 * @param intl Intl Provider
 * @returns Localized field specific Error Message (or original error string if nothing was found)
 */
export const formatErrorMsg = (error: ErrorType, inputId: InputIDs, intl: IntlShape) => {
  const errorMapping = {
    [`${Errors.REQUIRED}`]: formMessages[inputId].error, // get the correct message for each field
    [`${Errors.EMAIL}`]: specialErrorMessages.email,
    [`${Errors.NUMBERSONLY}`]: specialErrorMessages.numbersOnly,
    [`${Errors.NOSPECCHARS}`]: specialErrorMessages.noSpecChars,
    [`${Errors.NOSPECCHARSNONUMBERS}`]: specialErrorMessages.noSpecCharsNoNumbers,
    [`${Errors.INVALIDDATE}`]: specialErrorMessages.invalidDate,
  };

  // return formatted message if found or the original string as fallback
  return errorMapping[error]
    ? intl.formatMessage(errorMapping[error])
    : /* istanbul ignore next  */
      error;
};
